<template>
  <CContainer class="pt-5 mb-5" fluid>
    <CRow>
      <CCol class="col-7">
        <h3 class="pl-3 mb-0 pb-0">Roya</h3>
        <b-breadcrumb class="my-0 pt-1" style="border-bottom: 0px">
          <b-breadcrumb-item active>
            <CIcon name="cil-pen-alt" />
            Roya
          </b-breadcrumb-item>
        </b-breadcrumb>
      </CCol>
    </CRow>
    <CCard class="custom-card">
      <CCardBody class="px-0 pb-0">
        <CRow>
          <CCol class="col-xs-12 col-sm-10 col-md-9 col-lg-8 col-xl-7 ml-5">
            <CForm>
              <b-input-group class="custom-input-group-white">
                <b-input-group-prepend class="custom-prepend-middle">
                  <!-- <multiselect 
                    :allow-empty="false"
                    v-model="filter.periodBy" 
                    :options="filter.periodOptions"
                    :searchable="false"
                    id="period-table-roya"
                    placeholder="Select an option"
                    :showLabels="false"
                    openDirection="bottom"
                    label="text"
                    track-by="value"
                  >
                    <template slot="singleLabel" slot-scope="props">{{ props.option.text }}</template>
                    <template slot="option" slot-scope="props">{{ props.option.text }}</template>
                  </multiselect> -->
                  <b-form-select v-model="filter.periodBy" :options="filter.periodOptions"></b-form-select>
                </b-input-group-prepend>
                <b-input-group-append>
                  <b-form-datepicker
                    v-model="filter.periodStart" 
                    :min="filter.minPeriodStart"
                    :max="filter.maxPeriodStart"
                    id="filter-period-start"
                    placeholder="DD/MM/YYYY"
                    :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                    locale="id"
                    @context="onContextPeriodStart"
                    @input="filterDateRoyaTable"
                  ></b-form-datepicker>
                </b-input-group-append>
                <b-input-group-append>
                  <b-input-group-text>
                    ~
                  </b-input-group-text>
                </b-input-group-append>
                <b-input-group-append>
                  <b-form-datepicker
                    v-model="filter.periodEnd" 
                    :min="filter.minPeriodEnd"
                    :max="filter.maxPeriodEnd"
                    placeholder="DD/MM/YYYY"
                    :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                    locale="id"
                    @context="onContextPeriodEnd"
                    @input="filterDateRoyaTable"
                  ></b-form-datepicker>
                </b-input-group-append>
              </b-input-group>
            </CForm>
          </CCol>
        </CRow>
        <CRow class="mt-2">
          <CCol class="col-xs-12 col-sm-10 col-md-9 col-lg-8 col-xl-7 ml-5">
            <CForm>
              <b-input-group class="custom-input-group-white">
                <b-input-group-prepend class="custom-prepend-middle">
                  <!-- <multiselect 
                    :allow-empty="false"
                    v-model="filter.value" 
                    :options="filter.options"
                    :searchable="false"
                    id="filter-table-roya"
                    placeholder="Select an option"
                    :showLabels="false"
                    openDirection="bottom"
                    label="text"
                    track-by="value"
                  >
                    <template slot="singleLabel" slot-scope="props">{{ props.option.text }}</template>
                    <template slot="option" slot-scope="props">{{ props.option.text }}</template>
                  </multiselect> -->
                  <b-form-select v-model="filter.value" :options="filter.options" @change="changeFilterType"></b-form-select>
                </b-input-group-prepend>
                <b-input-group-prepend>
                  <b-form-select v-if="filter.value == 'documentStatus'" v-model="filter.filterSearch" :options="filter.filterValueDocumentStatusOptions" style="min-width: 206.5px;"></b-form-select>
                  <b-form-select v-else-if="filter.value == 'contractStatus'" v-model="filter.filterSearch" :options="filter.filterValueContractStatusOptions" style="min-width: 206.5px;"></b-form-select>
                  <b-form-input v-else maxlength="50" v-model="filter.filterSearch" autocomplete="off" placeholder="Search"></b-form-input>
                </b-input-group-prepend>
                <b-input-group-append>
                  <CButton size="sm" color="primary" type="submit" title="Filter Tabel Roya" :disabled="!royaTable.isLoaded" @click="filterRoyaTable">
                    <CIcon name="cil-magnifying-glass" />
                  </CButton>
                </b-input-group-append>
              </b-input-group>
            </CForm>
          </CCol>
        </CRow>
        <CRow class="mt-4" v-if="$helper.isRole($availRoles['Cabang']) || $helper.isRole($availRoles['FIMS']) || $helper.isRole($availRoles['HO']) || $helper.isRole($availRoles['Notaris'])">
          <CCol>
            <b-table striped hover show-empty
              responsive="xl"
              :items="royaTable.items"
              :fields="royaTable.fields"
              :busy="!royaTable.isLoaded"
              no-local-sorting no-sort-reset
              @sort-changed="onRoyaTableSortChanged"
            >
              <template #cell(contractNo)="row">
                {{ $helper.showData(row.value, "string") }}
              </template>
              <template #cell(customerName)="row">
                {{ $helper.showData(row.value, "string") }}
              </template>
              <template #cell(officeName)="row">
                {{ $helper.showData(row.value, "string") }}
              </template>
              <template #cell(contractDate)="row">
                {{ $helper.showData(row.value, "shortDate") }}
              </template>
              <template #cell(assignmentDate)="row">
                {{ $helper.showData(row.value, "shortDate") }}
              </template>
              <template #cell(documentStatus)="row">
                {{ $helper.showData(row.value, "string") }}
              </template>
              <template #cell(contractStatus)="row">
                {{ $helper.showData(row.value, "string") }}
              </template>
              <template #cell(newNotes)="row">
                <CBadge v-if="row.value" color="success">NEW</CBadge>
                <span v-else>-</span>
              </template>
              <template #cell(rejectValidation)="row">
                <span v-if="$helper.isEmpty(row.value) || row.value == false">-</span>
                <CBadge v-else color="danger">REJECTED</CBadge>
              </template>
              <template #cell(action)="row">
                <CButton size="sm" color="primary" title="Detail Roya" class="btn-icon mr-1 custom-button-action" @click="$router.push({name: 'Roya Detail', params: { royaId: row.item.contractId } })">
                  <b-icon icon="eye"></b-icon>
                </CButton>
              </template>
              <template slot="empty">
                <div v-if="!royaTable.isLoaded" class="text-center">
                  <b-spinner label="Fetching Data..."></b-spinner>
                </div> 
                <div v-else class="text-center">
                  Tidak ada data
                </div> 
              </template>
            </b-table>
            <CCardFooter>
              <PageSizer :totalRows="royaTable.totalRows" :page="royaTable.currentPage" @limit-change="onRoyaTableLimitChange" @page-change="onRoyaTablePageChange" />
            </CCardFooter>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
    <CRow>
      <CCol class="col-12">
        <b-btn variant="warning" class="float-right btn-sm custom-button-white" title="Download kontrak yang tertampil di tabel" style="width:12rem" :disabled="isDownloading || royaTable.items.length <= 0" @click="downloadContracts">
          <b-spinner small v-if="isDownloading" />
          <span v-else>Download Semua Kontrak</span>
        </b-btn>
      </CCol>
    </CRow>
  </CContainer>
</template>


<script>
export default {
  name: 'RoyaList',
  data() {
    const today = this.$moment().format('YYYY-MM-DD')
    return {
      isDownloading: false,
      filter: {
        value: "contractNo",
        options: [
          { value:"contractNo", text: "No. Kontrak" },
          { value:"customerName", text: "Nama Customer" },
          { value:"officeName", text: "Nama Office" },
          // { value:"contractDate", text: "Tanggal Kontrak" },
          // { value:"assignmentDate", text: "Tanggal Assign" },
          { value:"documentStatus", text: "Status Dokumen" },
          { value:"contractStatus", text: "Status Kontrak" },
        ],
        filterSearch: '',
        filterType: '',
        filterValue: '',
        filterValueDocumentStatusOptions: [
          { value: "Y", text: "Y" },
          { value: "N", text: "N" },
        ],
        filterValueContractStatusOptions: [
          { value: "WFN", text: "WFN" },
          { value: "STN", text: "STN" },
          { value: "WFA", text: "WFA" },
          { value: "RCE", text: "RCE" },
          { value: "MGR", text: "MGR" },
        ],
        periodOptions: [
          { value:"contractDate", text: "Tanggal Kontrak" },
          { value:"assignmentDate", text: "Tanggal Assign" }
        ],
        periodBy: "contractDate",
        periodStart: this.$moment().subtract(1, 'months').format('YYYY-MM-DD'),
        minPeriodStart: '',
        maxPeriodStart: today,
        periodEnd: today,
        minPeriodEnd: '',
        maxPeriodEnd: today
      },
      royaTable: {
        isLoaded: false,
        // table fields mirrors returned object from server-side
        fields: [
          {key: "contractNo", label: "No. Kontrak", sortable: true},
          {key: "customerName", label: "Nama Customer", sortable: true},
          {key: "officeName", label: "Nama Office", sortable: true},
          {key: "contractDate", label: "Tanggal Kontrak", sortable: true},
          {key: "assignmentDate", label: "Tanggal Assign", sortable: true},
          {key: "documentStatus", label: "Status Dokumen", sortable: true},
          {key: "contractStatus", label: "Status Kontrak", sortable: true},
          {key: "newNotes", label: "Notes", sortable: true},
          {key: "rejectValidation", label: "Validasi", sortable: true},
          { key: "action", label: "Aksi", sortable: false}
        ],
        items: [],
        sortBy: null,
        sortDesc: true,
        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        totalPages: 0
      }
    }
  },
  methods: {

    changeFilterType() {
      if (this.filter.value == "documentStatus") {
        this.filter.filterSearch = "Y"
      } else if (this.filter.value == "contractStatus") {
        this.filter.filterSearch = "WFN"
      } else{
        this.filter.filterSearch = null
      }
    },

    // update datepicker valid dates on change
    onContextPeriodStart() {
      this.filter.minPeriodEnd = this.filter.periodStart
      this.filter.maxPeriodEnd = this.$moment(this.filter.periodStart).add(1, 'years').format('YYYY-MM-DD')
    },
    onContextPeriodEnd() {
      this.filter.maxPeriodStart = this.filter.periodEnd
      this.filter.minPeriodStart = this.$moment(this.filter.periodEnd).subtract(1, 'years').format('YYYY-MM-DD')
    },
    downloadContracts(page = 1) {
      if(isNaN(page)) {
        this.royaTable.currentPage = 1
      }
      else {
        this.royaTable.currentPage = page
      }
      // URL builder
      let getUrl = "/excel/contractRoyaByte"
      
      let params = this.$helper.getBasePagedQuery(this.royaTable.currentPage - 1, this.royaTable.perPage)
      if(!this.$helper.isEmpty(this.filter.periodBy)) {
        params['periodBy'] = this.filter.periodBy
        if(!this.$helper.isEmpty(this.filter.periodStart) && !this.$helper.isEmpty(this.filter.periodEnd)){
          params['periodStart'] = this.filter.periodStart
          params['periodEnd'] = this.filter.periodEnd
        }
      }
      if(!this.$helper.isEmpty(this.filter.filterType) && !this.$helper.isEmpty(this.filter.filterValue)) {
        params['filterType'] = this.filter.filterType
        params['filterValue'] = this.filter.filterValue
      }
      if(this.royaTable.sortBy != null) {
        params['sortBy'] = this.royaTable.sortBy
        params['asc'] = !this.royaTable.sortDesc
      }
      
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['Cabang']) || this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO']) || this.$helper.isRole(this.$availRoles['Notaris'])){
        this.isDownloading = true
        this.$axios.get(getUrl, {
          // necessary to avoid encoding returned bytes
          params: params, 
          responseType: 'blob',
          timeout: 300000
        }).then(response => {
          if(response.status == 200){
            // create file Blob and download according to extension
            let blob=new Blob([response.data], {type: "application/octet-stream"})
            let link=document.createElement('a')
            link.href=window.URL.createObjectURL(blob)
            link.download= "Kontrak_Roya-" + Date.now() + ".xlsx"
            link.click();
          }
          else{
            this.$helper.toastError(this, "Download Kontrak Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Download Kontrak Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Download Kontrak Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.isDownloading = false
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },
    // update table with server-side processing on change
    onRoyaTableLimitChange(newPerPage) {
      this.royaTable.perPage = newPerPage
      // only fetch data when roles apply
      this.getRoyaTableItems()
    },
    onRoyaTablePageChange(newPage) {
      // only fetch data when roles apply
      this.getRoyaTableItems(newPage)
    },
    onRoyaTableSortChanged(ctx) {
      this.royaTable.sortBy = ctx.sortBy
      this.royaTable.sortDesc = ctx.sortDesc
      // only fetch data when roles apply
      this.getRoyaTableItems(this.royaTable.currentPage)
    },
    filterDateRoyaTable(){
      this.filter.filterType = this.filter.value
      this.filter.filterValue = this.filter.filterSearch
      this.getRoyaTableItems()
    },
    filterRoyaTable(event){
      event.preventDefault()
      this.filter.filterType = this.filter.value
      this.filter.filterValue = this.filter.filterSearch
      this.getRoyaTableItems()
    },
    // get paginated table contents from server-side
    getRoyaTableItems(page = 1) {
      if(isNaN(page)) {
        this.royaTable.currentPage = 1
      }
      else {
        this.royaTable.currentPage = page
      }
      // URL builder
      let getUrl = "/contract/roya/getAll"
      
      let params = this.$helper.getBasePagedQuery(this.royaTable.currentPage - 1, this.royaTable.perPage)
      if(!this.$helper.isEmpty(this.filter.periodBy)) {
        params['periodBy'] = this.filter.periodBy
        if(!this.$helper.isEmpty(this.filter.periodStart) && !this.$helper.isEmpty(this.filter.periodEnd)){
          params['periodStart'] = this.filter.periodStart
          params['periodEnd'] = this.filter.periodEnd
        }
      }
      if(!this.$helper.isEmpty(this.filter.filterType) && !this.$helper.isEmpty(this.filter.filterValue)) {
        params['filterType'] = this.filter.filterType
        params['filterValue'] = this.filter.filterValue
      }
      if(this.royaTable.sortBy != null) {
        params['sortBy'] = this.royaTable.sortBy
        params['asc'] = !this.royaTable.sortDesc
      }

      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['Cabang']) || this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO']) || this.$helper.isRole(this.$availRoles['Notaris'])){
        this.royaTable.isLoaded = false
        this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            // sessionStorage.setItem("filterRoyaPage", this.royaTable.currentPage)
            // sessionStorage.setItem("filterRoyaSize", this.royaTable.perPage)
            sessionStorage.setItem("filterRoyaPeriodBy", this.filter.periodBy)
            sessionStorage.setItem("filterRoyaPeriodStart", this.filter.periodStart)
            sessionStorage.setItem("filterRoyaPeriodEnd", this.filter.periodEnd)
            sessionStorage.setItem("filterRoyaType", this.filter.filterType)
            sessionStorage.setItem("filterRoyaValue", this.filter.filterValue)
            // sessionStorage.setItem("filterRoyaSortBy", this.royaTable.sortBy)
            // sessionStorage.setItem("filterRoyaAsc", this.royaTable.sortDesc)
            this.royaTable.items = response.data.data.data
            this.royaTable.totalRows = response.data.data.totalElements
            this.royaTable.totalPages = response.data.data.totalPages
          }
          else{
            this.$helper.toastError(this, "Load Daftar Roya Gagal! " + (response.data.reason ? response.data.reason : ""))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar Roya Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Load Daftar Roya Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.royaTable.isLoaded = true
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    }
  },
  computed: {
  },
  mounted() {
    // if(!this.$helper.isEmpty(sessionStorage.getItem("filterRoyaPage"))){
    //   this.royaTable.currentPage = sessionStorage.getItem("filterRoyaPage")
    // }
    // if(!this.$helper.isEmpty(sessionStorage.getItem("filterRoyaSize"))){
    //   this.royaTable.perPage = sessionStorage.getItem("filterRoyaSize")
    // }
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterRoyaPeriodBy"))){
      this.filter.periodBy = sessionStorage.getItem("filterRoyaPeriodBy")
    }
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterRoyaPeriodStart"))){
      this.filter.periodStart = sessionStorage.getItem("filterRoyaPeriodStart")
    }
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterRoyaPeriodEnd"))){
      this.filter.periodEnd = sessionStorage.getItem("filterRoyaPeriodEnd")
    }
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterRoyaType"))){
      this.filter.filterType = sessionStorage.getItem("filterRoyaType")
      this.filter.value = sessionStorage.getItem("filterRoyaType")
    }
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterRoyaValue"))){
      this.filter.filterValue = sessionStorage.getItem("filterRoyaValue")
      this.filter.filterSearch = sessionStorage.getItem("filterRoyaValue")
    }
    // if(!this.$helper.isEmpty(sessionStorage.getItem("filterRoyaSortBy"))){
    //   this.royaTable.sortBy = sessionStorage.getItem("filterRoyaSortBy")
    // }
    // if(!this.$helper.isEmpty(sessionStorage.getItem("filterRoyaAsc"))){
    //   this.royaTable.sortDesc = (sessionStorage.getItem("filterRoyaAsc") === 'true' ? true : false)
    // }
    // get table contents on page load
    this.getRoyaTableItems()
  },
  created() {
  }
}
</script>

<style>

</style>
